// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/css/icons.css
// module id = 92
// module chunks = 0